import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import { handleLogin } from "../../../store/user";
import { getSetting } from "../../../store/scheduler";

import LoginForm from "../../login/component/loginForm";
import { useMediaQuery } from "react-responsive";
import { Container } from "./styled";

const ShoppingLogin = () => {
  const location = useLocation();
  const user = useSelector((state) => state?.user?.data[0]);
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { homepageInfo, theme } = useOutletContext();
  const { url } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      dispatch(handleLogin(user));
      navigate("/shop");
    }
  }, [homepageInfo, user]);

  const getMyDomain = async (cmpnyNo) => {
    if (!cmpnyNo) return "";

    const url = "/api/domainSettingLoad";
    const req = { delYn: "N", cmpnyNo };

    const res = await axios.post(url, req);

    if (res.data.domain) {
      return res.data.domain;
    } else {
      return "";
    }
  };

  const updateCart = async (mber) => {
    const url = "/erp/cart/upsert";
    const localCart = JSON.parse(localStorage.getItem("cart")) || [];

    const promises = localCart.map((product) => {
      const body = {
        input: {
          mberNo: mber.mberNo,
          platform: "MULTI_PAGE",
          ...product,
        },
      };
      return axios.post(url, body);
    });

    try {
      const res = await Promise.all(promises);
      localStorage.removeItem("cart");
    } catch (err) {
      console.error(err);
    }
  };

  const getSchedulerSetting = async (mber) => {
    // const domain = await getMyDomain(mber.cmpnyNo);

    const apiUrl = "/api/toktokSettingList";
    const body = { mberNo: mber.mberNo };
    const res = await axios.post(apiUrl, body);

    if (res.request.status === 200) {
      dispatch(getSetting(res.data));
      const localCart = JSON.parse(localStorage.getItem("cart")) || [];
      if (localCart && localCart.length > 0) {
        updateCart(mber);
      }
      const pathname = location?.state?.path;

      const fullPath = ["/shop", url, pathname].filter(Boolean).join("/");
      navigate(fullPath, {
        state: pathname ? { tabIndex: location?.state?.tabIndex } : undefined,
      });
    }
  };

  return (
    <Container className={`theme-${theme}`}>
      <LoginForm getSchedulerSetting={getSchedulerSetting} url={url} homepageInfo={homepageInfo} />
    </Container>
  );
};

export default ShoppingLogin;
